<template>
  <div class="container-opern">
    <el-dialog
      title="新增关联曲谱"
      :visible="dialogVisible"
      @close="handleCloseDialog"
      width="1046px"
    >
      <common-search-form-wrapper :hiddenExpand="true" :reset="handleReset">
        <el-form
          size="mini"
          ref="form"
          :model="searchInfo"
          label-width="72px"
          class="mwow-form"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="曲谱名称：" prop="name">
                <el-input
                  v-model="searchInfo.name"
                  placeholder="请输入曲谱名称"
                  clearable
                  maxlength="100"
                  @change="handleSearch"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="乐器类型：" prop="type">
                <el-select
                  v-model="searchInfo.instrument_ids"
                  placeholder="请选择"
                  ref="multiSelect"
                  multiple
                  @change="handleSearch"
                  clearable
                >
                  <el-option
                    v-for="item in instrumentList"
                    :key="item.instrument_id"
                    :label="item.name"
                    :value="Number(item.instrument_id)"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上传时间：" prop="create_time">
                <common-date-range-selector
                  v-model="searchInfo.create_time"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="handleSearch"
                  :clearable="true"
                >
                </common-date-range-selector>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="APP状态：" prop="status">
                <el-radio-group
                  v-model="searchInfo.status"
                  @change="handleSearch"
                >
                  <el-radio-button :label="-1">全部</el-radio-button>
                  <el-radio-button :label="1">已上架</el-radio-button>
                  <el-radio-button :label="2">已下架</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="教学端状态："
                prop="teach_status"
                label-width="84px"
              >
                <el-radio-group
                  v-model="searchInfo.teach_status"
                  @change="handleSearch"
                >
                  <el-radio-button :label="-1">全部</el-radio-button>
                  <el-radio-button :label="1">已上架</el-radio-button>
                  <el-radio-button :label="2">已下架</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="" label-width="0px">
                <div
                  class="mwow-button-filled success"
                  @click="handleMultiRelate"
                >
                  批量关联
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </common-search-form-wrapper>
      <el-table
        size="mini"
        v-horizontal-scroll
        :data="tableData"
        stripe
        style="width: 100%; margin-top: 20px"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="
            (row) => {
              return selected.indexOf(row.music_id) < 0;
            }
          "
        >
        </el-table-column>
        <el-table-column label="曲谱名称" prop="name"> </el-table-column>
        <el-table-column label="APP状态" prop="status">
          <template slot-scope="scope">
            <span v-show="scope.row.status === 1">已上架</span>
            <span v-show="scope.row.status === 2">已下架</span>
          </template>
        </el-table-column>
        <el-table-column label="教学端状态" prop="teach_status">
          <template slot-scope="scope">
            <span v-show="scope.row.teach_status === 1">已上架</span>
            <span v-show="scope.row.teach_status === 2">已下架</span>
          </template>
        </el-table-column>
        <el-table-column label="演唱者" prop="singer_list">
          <template slot-scope="scope">{{
            scope.row.singer_list
              .map((item) => {
                return item.name;
              })
              .join(",")
          }}</template>
        </el-table-column>
        <el-table-column label="乐器" prop="instrument_list">
          <template slot-scope="scope">{{
            scope.row.instrument_list
              .map((item) => {
                return item.name;
              })
              .join(",")
          }}</template>
        </el-table-column>
        <el-table-column label="上传用户" prop="admin_name"> </el-table-column>
        <el-table-column label="上传时间" prop="create_time" width="142">
        </el-table-column>
        <el-table-column label="操作" prop="operate" width="150">
          <template slot-scope="scope">
            <div>
              <div class="mwow-button" @click="handleRelate(scope.row)">
                关联
              </div>
              <div
                class="mwow-button"
                style="margin-left: 10px"
                @click="handleView(scope.row)"
              >
                预览
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="overflow: hidden">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :style="{ float: 'right', padding: '20px' }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </el-dialog>
    <!-- 曲谱预览 -->
    <el-dialog
      :title="sheetPreviewDialogTitle + '预览'"
      :visible.sync="sheetPreviewDialogVisible"
      width="290px"
    >
      <sheet-preview-dialog
        :music-id="sheetPreviewDialogId"
      ></sheet-preview-dialog>
      <p
        style="
          text-align: center;
          font-size: 14px;
          color: #333;
          margin-top: 12px;
        "
      >
        请使用音乐窝APP扫码预览
      </p>
    </el-dialog>
  </div>
</template>
<script>
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import { getRelateSheetListApi, getSheetInstrumentListApi } from "@/api/score";
import { dateFormat } from "@/utils/timeFormat";
import sheetPreviewDialog from "./sheetPreviewDialog.vue";
export default {
  props: ["visible", "selected"],
  components: {
    commonDateRangeSelector,
    commonSearchFormWrapper,
    sheetPreviewDialog,
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      searchInfo: {
        name: "",
        instrument_ids: [],
        create_time: [],
        status: -1,
        teach_status: -1,
      },
      tableData: [],
      multipleSelection: [],
      instrumentList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      dialogVisible: false,
      sheetPreviewDialogVisible: false,
      sheetPreviewDialogId: "",
      sheetPreviewDialogTitle: "",
    };
  },
  watch: {
    visible(n) {
      if (n) {
        this.dialogVisible = true;
        this.handleSearch();
        if (this.instrumentList.length === 0) {
          getSheetInstrumentListApi().then((res) => {
            this.instrumentList = res.data.list;
          });
        }
      }
    },
  },
  methods: {
    solveSearchParams(options) {
      let params = { ...options };
      if (this.searchInfo.name) {
        params.name = this.searchInfo.name;
      }
      if (
        this.searchInfo.instrument_ids &&
        this.searchInfo.instrument_ids.length > 0
      ) {
        params.instrument_ids = this.searchInfo.instrument_ids;
      }
      if (
        this.searchInfo.create_time &&
        this.searchInfo.create_time.length === 2
      ) {
        params.create_start_time =
          new Date(this.searchInfo.create_time[0]).getTime() / 1000;
        params.create_end_time =
          new Date(this.searchInfo.create_time[1]).getTime() / 1000 +
          24 * 60 * 60 -
          1;
      }
      if (this.searchInfo.status >= 0) {
        params.status = this.searchInfo.status;
      }
      if (this.searchInfo.teach_status >= 0) {
        params.teach_status = this.searchInfo.teach_status;
      }
      return params;
    },
    getList(options) {
      let params = this.solveSearchParams(options);
      getRelateSheetListApi(params).then((res) => {
        res.data.list.map((item) => {
          item.create_time =
            item.create_time === 0
              ? "-"
              : dateFormat("YYYY-mm-dd HH:MM", item.create_time * 1000);
        });
        this.tableData = res.data.list;
        this.page = res.data.page;
        this.total = res.data.total;
      });
    },
    handleReset() {
      this.searchInfo = {
        name: "",
        instrument_ids: [],
        create_time: [],
        status: -1,
        teach_status: -1,
      };
      this.handleSearch();
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handleSelectionChange(arr) {
      this.multipleSelection = arr;
    },
    handleMultiRelate() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          type: "warning",
          message: "请先选择曲谱",
        });
        return false;
      }
      this.$emit("change", this.multipleSelection);
      this.dialogVisible = false;
    },
    handleRelate(row) {
      this.$emit("change", [row]);
      this.dialogVisible = false;
    },
    handleView(row) {
      this.sheetPreviewDialogId = row.music_id;
      this.sheetPreviewDialogVisible = true;
      this.sheetPreviewDialogTitle = row.name;
    },
    handleCloseDialog() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
